export default "__VITE_ASSET__f3498a10__"